import { checkDate } from "common/helpers/Date";
import { List, Record } from "immutable";
import { DateStringNumber } from "common/records";

export type BillingKind = "maxio" | "chargebee";

export const fromJSON = (data: Partial<IBillingSubscriptionData>): BillingSubscriptionRecord => {
  const recordData: IBillingSubscriptionRecord = { ...(data as any) };

  recordData.item_price_id =
    data.payload?.content?.subscription?.subscription_items?.find((i) => i.item_type === "plan")?.item_price_id || "";

  if (recordData.created_at) {
    recordData.created_at = checkDate(recordData.created_at);
  }

  if (recordData.updated_at) {
    recordData.updated_at = checkDate(recordData.updated_at);
  }
  return new BillingSubscriptionRecord(recordData);
};

export interface IBillingSubscriptionData {
  id: number;
  org_id: number;
  min_value: number;
  min_value_through: Date;
  kind: string;
  billable_types: string[];
  metadata: {
    hubspot_deal_id: number;
    chargebee_subscription_id: string;
  };
  payload?: {
    content?: {
      subscription?: {
        id: string;
        billing_period: number;
        billing_period_unit: string;
        customer_id: string;
        status: string;
        deleted: false;
        object: string;
        currency_code: string;
        subscription_items?: { item_price_id: string; item_type: string }[];
        exchange_rate: number;
        base_currency_code: string;
      };
    };
  };
  archive_number: null;
  archived_at: null;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  customer_id: string;
  customer_email: string;
}

export interface IBillingSubscriptionRecord {
  id: number;
  org_id: number;
  item_price_id: string;
  min_value: number;
  min_value_through: Date;
  kind: string;
  billable_types: List<string>;
  metadata: {
    hubspot_deal_id: number;
    chargebee_subscription_id: string;
  };
  archive_number: null;
  archived_at: null;
  created_at: Date;
  updated_at: Date;
  customer_id: string;
  customer_email: string;
}

export const defaultBillingProps: IBillingSubscriptionRecord = {
  id: 0,
  org_id: 0,
  item_price_id: "",
  min_value: 0,
  min_value_through: new Date(),
  kind: "",
  billable_types: List(),
  metadata: {
    hubspot_deal_id: 0,
    chargebee_subscription_id: "",
  },
  archive_number: null,
  archived_at: null,
  created_at: new Date(),
  updated_at: new Date(),
  customer_id: "",
  customer_email: "",
};

export class BillingSubscriptionRecord
  extends Record<IBillingSubscriptionRecord>(defaultBillingProps)
  implements IBillingSubscriptionRecord {}
